import withConfigTransport from '../../../../services/config-transport/withConfigTransport'
import _VaSelectOption from './VaSelectOption.vue'

export const VaSelectOption = withConfigTransport(_VaSelectOption)
